import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","pa-5":""}},[_c(VCard,{staticClass:"mx-auto",attrs:{"max-width":"344"}},[_c(VCardText,[_c('div',[_vm._v("\n        You are not authorized to view this page\n      ")]),_c('div',{staticClass:"text--primary"},[_vm._v("\n        Click here to "),_c('a',{attrs:{"href":_vm.defaultRoute}},[_vm._v("Go Back")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }